<ng-container *ngTemplateOutlet="sidebarTemplate; context:{ $implicit: isScreenSmall | async, hasNotification: notifications() }" />

<ng-template #sidebarTemplate let-isSmall let-hasNotification="hasNotification">
    <mat-sidenav-container [class.has-notification]="hasNotification">
        <pd-header (menuOpened)="toggleSidenav()"  (profileOpened)="toggleProfile()"/>
        @if (isSmall) {
            <mat-sidenav [opened]="false" mode="over" [fixedInViewport]="true">

              @if (showContent =='MENU') {
                <pd-menu (menuClosed)="toggleSidenav()" />
              } @else {
                <app-profile-menu [showHeader]="true" (profileClosed)="toggleSidenav()"></app-profile-menu>
              }

            </mat-sidenav>
        }

        @if (hasNotification; as notifications) {
            <div [class]="'notification ' + notifications.color">
                <i [class]="'icon-size-18 icon-' + notifications.icon"></i>
                {{notifications.message}}
            </div>
        }
        <main>
            @if (!isSmall) {
                <pd-menu (menuClosed)="toggleSidenav()" />
            }
            <div class="content">
                <div class="inner-content" [class]="activatedRouteClassName">
                    <router-outlet />
                </div>
            </div>
        </main>
    </mat-sidenav-container>
</ng-template>
